import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { ID } from 'shared/types/id';

export const useAllTasksOnSectionCollapse = () => {
  const updateSettings = useUpdateUserSettings();

  return useCallback(
    (changedSectionIds: ID[]) =>
      updateSettings({
        filters: {
          allTasks: {
            collapsedSections: changedSectionIds,
          },
        },
      }),
    [updateSettings],
  );
};
